import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWifi } from "@fortawesome/free-solid-svg-icons";

type Props = {};


const NetworkDetect: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false)

    const handleDialogHide = () => {
     setOpen(false)
    };

    const connectionDetect = () => {
      if (!navigator.onLine) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }

    useEffect(() => {
      const interval = setInterval(() => {
        connectionDetect();
      }, 500)
  
      return () => {
        clearInterval(interval)
      }
    })

  return (
    <>
      <Modal
        id={"network-detect-modal"}
        show={open}
        animation={false}
        backdropClassName="customDarkModalBackdrop inner in"
        onHide={handleDialogHide}
        backdrop={'static'}
        keyboard={false}
        centered
      >
        <Modal.Header
          className="purpleModalHeader"
          style={{ borderBottom: 0 }}
        >
            <Modal.Title>
              <FontAwesomeIcon
              icon={faWifi}
              style={{color:'red', fontSize:"19px", verticalAlign: "middle"}}
              /> No Internet Connection
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">Please reconnect to the internet to continue using ReadyCoach.</p>
          <p className="mb-1 ml-4 font-weight-bold"> If issues persist:</p>
          <ul>
            <li> Restart your connection on this device. </li>
            <li> Move closer to your Wi-Fi access point. </li>
          </ul>
          <hr/>
        <div className="text-center">
            <button className="blueBtnSm" onClick={connectionDetect}>
               RETRY
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default NetworkDetect;